package devxertech.com.pages.career

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.pages.career.careerAbout.CareerAboutSection
import devxertech.com.pages.career.careerEmployee.CareerEmployee
import devxertech.com.pages.career.careerOpenings.CareerOpenings
import devxertech.com.pages.commons.CommonArrow
import devxertech.com.pages.commons.CommonHeader
import devxertech.com.pages.dashboard.footerSection.HomepageFooter
import devxertech.com.pages.dashboard.ratingSection.RatingSection
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Res

@Page("/career-page")
@Composable
fun CareerPage() {
    val sitePalette = ColorMode.current.toSitePalette()
    val breakpoint = rememberBreakpoint()


    Column(
        modifier = Modifier.fillMaxSize().backgroundColor(sitePalette.bodyBackgroundSecondary.rgb)
    ) {
        CommonHeader(
            image = Res.Image.career_header,
            breakpoint = breakpoint,
            headingText = "Careers at Devxer",
            descriptionText = "Grow with us! Become a valued member of our expanding team.",
            startProject = false,
            careerHeight = true,
            careerHeaderText = true,
            careerFontSize = true,
            careerHeightModification = true,
            heightModification = true
        )
        CommonArrow("Careers")
        CareerOpenings(breakpoint)
        CareerAboutSection(breakpoint, sitePalette)
        CareerEmployee()
        RatingSection(breakpoint)
        HomepageFooter(breakpoint)

    }
}